var exports = {
  "P0": "iconWrapper__kRqMna",
  "Kk": "icon__j8PkLd",
  "gK": "icon-animate__H_0XjD",
};

module.exports = exports;
